module.exports = __webpack_public_path__ + "static/futura-book-cfebb4c6b622e4148f0b2d679f9f3d5b.ttf";